export default __webpack_public_path__ + "static/media/belt_of_vicious_frenzy.d833a205.jpg";